import React from 'react';

const VARIANTS = {
  success: { bg: '#E8F5EE', titleColor: '#2D7A4A', bullet: '#2D7A4A' },
  warning: { bg: '#FFF4D6', titleColor: '#B8860B', bullet: '#B8860B' },
};

export default function EngagementBox({ title, items = [], variant = 'success' }) {
  const v = VARIANTS[variant] || VARIANTS.success;
  return (
    <div style={{ ...styles.box, background: v.bg }}>
      <h3 style={{ ...styles.title, color: v.titleColor }}>{title}</h3>
      <ul style={styles.list}>
        {items.map((item, i) => (
          <li key={i} style={styles.item}>
            <span style={{ ...styles.bullet, background: v.bullet }} aria-hidden />
            <span style={styles.itemText}>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

const styles = {
  box: {
    borderRadius: 12,
    padding: 14,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  title: {
    margin: 0,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: '-0.005em',
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    fontSize: 13,
    color: '#1A1A1A',
    lineHeight: 1.4,
  },
  bullet: {
    width: 5,
    height: 5,
    borderRadius: 999,
    marginTop: 7,
    flexShrink: 0,
  },
  itemText: {
    flex: 1,
  },
};
